import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { ZH_APOSTILLE } from "@/data/zh-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/zh/apostille";
const C = ZH_APOSTILLE;

export const Route = createFileRoute("/zh/apostille")({
  head: () => ({
    meta: [
      { title: ctaTitle("泰国海牙认证 Apostille 代办 | NYC Legal 曼谷 (中文)", "/zh/apostille", "th")},
      { name: "description", content: ctaDesc("曼谷 Apostille 代办:中泰双向 MFA 海牙认证 + 公证 + 翻译,5–7 个工作日完成。中国 2023.11 加入海牙公约。中文专员接待。. Free consultation — message us and get a same-day answer.", "/zh/apostille", "th")},
      { property: "og:title", content: ctaTitle("泰国海牙认证 Apostille 代办 (中文) | NYC Legal", "/zh/apostille", "th")},
      { property: "og:description", content: ctaDesc("中泰 Apostille 一站式:公证 + 翻译 + MFA。微信 / LINE 中文报价。", "/zh/apostille", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "zh_CN" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/apostille" },
          { hreflang: "en", path: "/en/apostille" },
          { hreflang: "zh", path: "/zh/apostille" },
          { hreflang: "x-default", path: "/apostille" },
        ],
        "/apostille",
      ),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LegalService",
          name: "NYC Legal — 泰国海牙认证 Apostille",
          url: `${SEO_SITE}${PATH}`,
          areaServed: ["TH", "CN"],
          inLanguage: "zh",
          priceRange: "฿1,500–฿5,000",
          serviceType: "Apostille Service · MFA Legalisation",
          provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "zh",
          mainEntity: C.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "HowTo",
          inLanguage: "zh",
          name: "泰国 Apostille 办理流程",
          totalTime: "P7D",
          estimatedCost: { "@type": "MonetaryAmount", currency: "THB", value: "1500" },
          step: C.steps.map((s) => ({ "@type": "HowToStep", name: s.name, text: s.text })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "首页", item: `${SEO_SITE}/zh` },
            { "@type": "ListItem", position: 2, name: "Apostille", item: `${SEO_SITE}${PATH}` },
          ],
        }),
      },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
